import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';

const WorkspacesListPage = lazy(() => import('./WorkspacesListPage'));
const WorkspaceDetailPage = lazy(() => import('./WorkspaceDetailPage'));

export const workspaceRoutes: RouteObject[] = [
  {
    path: 'workspaces',
    element: (
      <ProtectedRoute action="workspaces:view">
        <WorkspacesListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: 'workspaces/:id',
    element: (
      <ProtectedRoute action="workspaces:view">
        <WorkspaceDetailPage />
      </ProtectedRoute>
    ),
  },
];
